export default [
  {
    path: '/comment/:id/:partyid',
    name: 'comment',
    redirect: {
      name: 'commentIndex'
    },
    meta: {
      title: '读红色故事，传红色基因',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/shuping/main'], resolve)
    },
    children: [
      {
        path: 'index',
        name: 'commentIndex',
        meta: {
          title: '读红色故事，传红色基因',
          NeedLogin: false,
          keepAlive: false
        },
        component: resolve => {
          require(['../views/shuping/index'], resolve)
        }
      },
      {
        path: 'rank',
        name: 'commentRank',
        meta: {
          title: '读红色故事，传红色基因',
          NeedLogin: false,
          keepAlive: false
        },
        component: resolve => {
          require(['../views/shuping/rank'], resolve)
        }
      },
      {
        path: 'detail/:bookid',
        name: 'commentDetail',
        meta: {
          title: '读红色故事，传红色基因',
          NeedLogin: false,
          keepAlive: false
        },
        component: resolve => {
          require(['../views/shuping/detail'], resolve)
        }
      },
      {
        path: 'report/:commentid',
        name: 'commentReport',
        meta: {
          title: '读红色故事，传红色基因',
          NeedLogin: false,
          keepAlive: false
        },
        component: resolve => {
          require(['../views/shuping/report'], resolve)
        }
      }
    ]
  }
]
